export const GET_CRITERIA = 'GET_CRITERIA';
export const GET_MULTI_STUDENT = 'GET_MULTI_STUDENT';
export const GET_STUDENT_STATUS = 'GET_STUDENT_STATUS';
export const GET_REPORTS_DATA = 'GET_REPORTS_DATA';
